module.exports = __webpack_public_path__ + "img/speaker.5dfd73cc.svg";